import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'

const Footer = ({ copyright }) => (
  <footer className="footer">
    <nav className = "col-sm-offset-4 col-sm-8 col-xs-offset-1 col-xs-10">
      <ul>
        <li>&copy; {copyright}</li>
        <li>
          <Link
            to="/privacy"
          >
            Privacy
          </Link>
        </li>
        <li>
          <Link
            to="/legal">
              Legal
          </Link>
        </li>
      </ul>
    </nav>
  </footer>
)

Footer.proptypes = {
  copyright: PropTypes.string,
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.js